module.exports = __webpack_public_path__ + "static/media/gym-zoomed-5.65374f75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/gym-zoomed-5.jpg
// module id = 2388
// module chunks = 0